const Form = (function () {

    const $ = require('jquery');
    const self = {};

    self.toggle_label = function () {
        self.$labels.removeClass('selected');
        self.$labels.filter(':has(:checked)').addClass('selected');
    };

    self.renderForm = function () {

        $('.ginput_container_checkbox').parent().addClass('checkbox-field');

        //  GravityForms - custom checkboxes and radio's
        var $choiceBoxes = $('.gfield_radio li, .gfield_checkbox li');

        if ($choiceBoxes.length > 0) {

            $choiceBoxes.each(function () {

                var $this = $(this);
                var oldInput = $this.find('input');
                var className = $this.parent().attr('class').replace('gfield_', '');

                $this
                    .find('label')
                    .addClass(className)
                    .prepend(oldInput);
            });

        }

        //  Custom radio
        self.$labels = $('.checkbox, .radio').closest('label').click(self.toggle_label);
        self.toggle_label();

    };

    self.init = function () {

        self.renderForm();

        //  Form manipulations on submit (AJAX form)
        App.Globals.$document.on('gform_post_render', function () {

            self.renderForm();

        });

    };

    return self;

}());

module.exports = Form;
